import React from 'react';
import { Page, Text, View, Image } from '@react-pdf/renderer';
import dateFormat from 'dateformat';

import hgsdLogo from '../../black-textHGSDlogo400px.png';
import ftBendLogo from '../../fbsd_logo_clr_rgb.png';

export default function AppendixF({ styles, data, year, month, footer }) {
  return (
    <Page size='A4'>
      <View style={styles.pageTitle}>
        <Text style={styles.pageTitle}></Text>
      </View>
      <View style={styles.document}>
        <View style={[styles.row, styles.borderBottom]}>
          <Image
            src={window.config.client === 'FT-BEND' ? ftBendLogo : hgsdLogo}
            style={styles.logo}
          />
          <Text style={styles.logoLabel}>Appendix F</Text>
        </View>
        <View style={[styles.row, styles.borderBottom]}>
          <Text style={styles.logo} />
          <Text style={styles.logoLabel}>Advertised in Error</Text>
        </View>
        <View style={styles.section}>
          {data.length === 0 ? (
            <View style={styles.column}>
              <Text>NONE</Text>
            </View>
          ) : null}
          {data.map((permit, i) => (
            <View style={styles.section} key={i}>
              <View>
                <Text style={styles.headerLabel}>PERMITTEE:</Text>
                <Text>{permit.PERMITTEE}</Text>
              </View>
              <View>
                <Text style={styles.headerLabel}>DATE OF HEARING:</Text>
                <Text>{` ${dateFormat(
                  permit.HEARING_DATE,
                  'mmmm d, yyyy',
                  true
                )}`}</Text>
              </View>
            </View>
          ))}
        </View>
      </View>
      <View fixed style={styles.footer}>
        {/* <Text style={styles.data}>{footer}</Text> */}
        <Text
          style={styles.data}
          render={({ pageNumber, totalPages }) =>
            `${footer} (${pageNumber}/${totalPages})`
          }
        />
      </View>
    </Page>
  );
}
